module.exports = __webpack_public_path__ + "static/brian-boals-vertical-d0ddd6af911e3b811ac6322551de1416.png";